import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global error handler for DataCloneError
window.addEventListener('error', (event) => {
  if (event.message?.includes('clone') || event.error?.name === 'DataCloneError') {
    console.warn('DataCloneError caught globally:', event.message);
    event.preventDefault(); // Prevent the error from showing
    return;
  }
});

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('clone') || event.reason?.name === 'DataCloneError') {
    console.warn('DataCloneError in promise caught globally:', event.reason?.message);
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
